import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (/^https?:\/\//i.test(req.url) || req.url.startsWith('/assets/')) return next(req);
  return next(req.clone({ url: `${environment.apiBaseUrl}${req.url}` }));
};
